"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAbortError = exports.HTTPClient = exports.HTTPClientError = void 0;
var zod_1 = require("zod");
var token_1 = require("./token");
var constants_1 = require("./constants");
var HTTPClientError = /** @class */ (function (_super) {
    __extends(HTTPClientError, _super);
    function HTTPClientError(errorMessage, traceId, httpStatusCode) {
        var _this = _super.call(this, errorMessage) || this;
        _this.traceId = traceId;
        _this.httpStatusCode = httpStatusCode;
        return _this;
    }
    return HTTPClientError;
}(Error));
exports.HTTPClientError = HTTPClientError;
var HTTPClient = /** @class */ (function () {
    function HTTPClient(env, host) {
        var _this = this;
        this.env = env;
        this.host = host;
        this.get = function (path, responseSchema, options) {
            if (options === void 0) { options = { abortInflightRequests: false }; }
            return __awaiter(_this, void 0, void 0, function () {
                var requestInit;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            requestInit = {
                                method: 'GET',
                                headers: { 'Content-Type': 'application/json' }
                            };
                            return [4 /*yield*/, this.fetcher(this.host + path, __assign(__assign({}, requestInit), options), responseSchema)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.post = function (path, responseSchema, body, options) {
            if (options === void 0) { options = { abortInflightRequests: false }; }
            return __awaiter(_this, void 0, void 0, function () {
                var requestInit;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            requestInit = {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify(body)
                            };
                            return [4 /*yield*/, this.fetcher(this.host + path, __assign(__assign({}, requestInit), options), responseSchema)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.delete = function (path, options) {
            if (options === void 0) { options = { abortInflightRequests: false }; }
            return __awaiter(_this, void 0, void 0, function () {
                var requestInit;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            requestInit = {
                                method: 'DELETE',
                                headers: { 'Content-Type': 'application/json' }
                            };
                            return [4 /*yield*/, this.fetcher(this.host + path, __assign(__assign({}, requestInit), options), zod_1.z.null())];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.fetcher = function (request, requestInitOpts, responseSchema) {
            var abortInflightRequests = requestInitOpts.abortInflightRequests, requestInit = __rest(requestInitOpts, ["abortInflightRequests"]);
            var token = (0, token_1.getToken)(_this.env);
            var abortController = new AbortController();
            var requestInitWithToken = __assign(__assign(__assign({}, requestInit), { headers: __assign(__assign({}, requestInit.headers), { Authorization: "Bearer ".concat(token) }) }), { signal: abortController.signal });
            var path = _this.getPath(request);
            if (abortInflightRequests) {
                var res = _this.inFlightRequests.find(function (req) { return req.path === path; });
                res === null || res === void 0 ? void 0 : res.abortController.abort();
                _this.inFlightRequests = _this.inFlightRequests.filter(function (req) { return req.path !== path; });
                var inFlightRequest = { path: path, abortController: abortController };
                _this.inFlightRequests.push(inFlightRequest);
            }
            return fetch(request, requestInitWithToken)
                .then(_this.checkStatus)
                .then(_this.parseJSON)
                .then(responseSchema.parseAsync);
        };
        this.checkStatus = function (response) { return __awaiter(_this, void 0, void 0, function () {
            var traceId, errorMessage, error;
            return __generator(this, function (_a) {
                if (response.ok) {
                    return [2 /*return*/, response];
                }
                else {
                    traceId = response.headers.get(constants_1.HEADER_TRACE_ID_KEY);
                    errorMessage = "Request to ".concat(response.url, " failed with ").concat(response.status);
                    error = new HTTPClientError(errorMessage, traceId, response.status);
                    throw error;
                }
                return [2 /*return*/];
            });
        }); };
        this.parseJSON = function (response) {
            if (response.status === 204) {
                return {};
            }
            return response.json();
        };
        this.isRequest = function (request) {
            return request.url !== undefined;
        };
        this.getPath = function (request) {
            if (_this.isRequest(request))
                return request.url;
            else
                return request;
        };
        this.inFlightRequests = [];
    }
    return HTTPClient;
}());
exports.HTTPClient = HTTPClient;
var isAbortError = function (error) {
    return error instanceof Error && error.name === 'AbortError';
};
exports.isAbortError = isAbortError;
